import axios from "axios";
import { useEffect, useState } from "react";
import { singletonHook } from "react-singleton-hook";
import { env } from "../env";
import { HeaperServiceEndpoint } from "../types";
/**
 * Fetch the `HeaperIdentity` object for a user.  This can only be invoked after `useHeaper(promotionLevel)` in your app as it is dependent upon the `PromotionLevel` passed and will return immediately from the react-query cache.
 */
const useHeaperIdentityImpl = () => {
    const [identity, setIdentity] = useState(env.getHeaperIdentity());
    const headers = {
        ...env.getAuthHeaders(),
        ...env.getAppPlatformHeaders(),
    };
    useEffect(() => {
        if (headers && !identity) {
            axios
                .request({
                method: "get",
                url: `${HeaperServiceEndpoint[env.getPromotionLevel()]}/project/${env.getHeapProjectId()}/who-am-i`,
                headers,
            })
                .then(({ data }) => {
                env.setHeaperIdentity(data);
                setIdentity(data);
            })
                .catch((err) => {
                setIdentity(undefined);
                console.error("useHeaperIdentity() error", err);
            });
        }
    }, [headers]);
    return identity;
};
export const useHeaperIdentity = singletonHook(env.getHeaperIdentity(), useHeaperIdentityImpl, { unmountIfNoConsumers: true });
//# sourceMappingURL=useHeaperIdentity.js.map